module.exports = __webpack_public_path__ + "static/img/pros-3.8e6770b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pros-3.png
// module id = UP8I
// module chunks = 1